var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLuz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 528.07 511.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #990089;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "LUZ",
    className: "cls-1",
    d: "M490.21,468.08h0c-23.14,13.11-55.82,24.09-94.49,31.73-39.88,7.89-85.43,12.05-131.71,12.04-46.28,0-91.83-4.19-131.71-12.08-38.67-7.66-71.34-18.64-94.48-31.76h0c-36.15-20.88-48.58-67.29-27.7-103.44L198.83,37.86C212.24,14.64,237.25.13,264.09,0c26.85.14,51.85,14.65,65.26,37.88l188.6,326.77c20.87,36.16,8.43,82.56-27.73,103.43Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuz);
export default __webpack_public_path__ + "static/media/LUZ.5262d729a381153ee691158f6e62b8a2.svg";
export { ForwardRef as ReactComponent };